import React, { useState, useEffect } from 'react';
import Modal from '../../../Components/Modal';
import ModalBody from '../../../Components/ModalBody';
import ModalFooter from '../../../Components/ModalFooter';
import ModalHeader from '../../../Components/ModalHeader';
import Btn from '../../../Components/Btn';
//import SelectCustom from '../../../Components/SelectCustom';
//import FieldSet from '../../../Components/FieldSet';
import { Article } from '../../../Components/Article/Article';
import { Radio } from '../../../Components/Checkbox/Checkbox';

export enum ExistingProductsFieldUpdateStrategy {
	PreviousNonEmptyFieldsHavePrecedence = 'PreviousNonEmptyFieldsHavePrecedence',
	TheseNonEmptyFieldsHavePrecedence = 'TheseNonEmptyFieldsHavePrecedence'
}

export const KeepNewProductsDescription = 'Yes, this source can add products that are not in other previous sources';
export const NotKeepNewProductsDescription = 'No, this source will not add products that are not in other previous sources';
export const PreviousNonEmptyFieldsHavePrecedenceDescription = 'No, non empty fields of previous source have precedence';
export const TheseNonEmptyFieldsHavePrecedenceDescription = 'Yes, non empty fields of this source have precedence';

type ProductFeedStrategyModalType = {
	existingProductsFieldUpdateStrategy: ExistingProductsFieldUpdateStrategy | undefined,
	keepNewProducts: boolean | undefined,
	isOpened: boolean,
	handleClose: () => void,
	handleSave: (keepNewProducts: boolean, existingProductsFieldUpdateStrategy: ExistingProductsFieldUpdateStrategy) => void
}

export default function ProductFeedStrategyModal({
	existingProductsFieldUpdateStrategy,
	keepNewProducts,
	isOpened,
	handleClose,
	handleSave
}: ProductFeedStrategyModalType) {

	const [localKeepNewProducts, setLocalKeepNewProducts] = useState<boolean>(keepNewProducts ?? false);
	const [localExistingProductsFieldUpdateStrategy, setLocalExistingProductsFieldUpdateStrategy] = useState<ExistingProductsFieldUpdateStrategy>(existingProductsFieldUpdateStrategy ?? ExistingProductsFieldUpdateStrategy.PreviousNonEmptyFieldsHavePrecedence);

	const save = () => handleSave(localKeepNewProducts, localExistingProductsFieldUpdateStrategy);

	useEffect(() => {
		if (!isOpened) return;
		setLocalKeepNewProducts(keepNewProducts ?? false);
		setLocalExistingProductsFieldUpdateStrategy(existingProductsFieldUpdateStrategy ?? ExistingProductsFieldUpdateStrategy.PreviousNonEmptyFieldsHavePrecedence);
	}, [isOpened]);

	return (
		<Modal
			isOpen={isOpened}
			width={640}
			onClose={() => handleClose()}
		>
			<ModalHeader>
				Merge strategies
			</ModalHeader>
			<ModalBody>
				<Article title="Add new products?">
					<Radio
						forcedChecked={localKeepNewProducts === true}
						label={KeepNewProductsDescription}
						onChange={() => setLocalKeepNewProducts(true)}
						fullWidth={true}
					/>
					<Radio
						forcedChecked={localKeepNewProducts === false}
						label={NotKeepNewProductsDescription}
						onChange={() => setLocalKeepNewProducts(false)}
						fullWidth={true}
					/>
				</Article>
				<Article title="Override existing product fields?">
					<Radio
						forcedChecked={localExistingProductsFieldUpdateStrategy === ExistingProductsFieldUpdateStrategy.TheseNonEmptyFieldsHavePrecedence}
						label={TheseNonEmptyFieldsHavePrecedenceDescription}
						onChange={() => setLocalExistingProductsFieldUpdateStrategy(ExistingProductsFieldUpdateStrategy.TheseNonEmptyFieldsHavePrecedence)}
						fullWidth={true}
					/>
					<Radio
						forcedChecked={localExistingProductsFieldUpdateStrategy === ExistingProductsFieldUpdateStrategy.PreviousNonEmptyFieldsHavePrecedence}
						label={PreviousNonEmptyFieldsHavePrecedenceDescription}
						onChange={() => setLocalExistingProductsFieldUpdateStrategy(ExistingProductsFieldUpdateStrategy.PreviousNonEmptyFieldsHavePrecedence)}
						fullWidth={true}
					/>
				</Article>
			</ModalBody>
			<ModalFooter
				hasBorder={false}
				primaryAction={
					<Btn
						onClickFunction={() => save()}
						message="Confirm"
						color="primary"
					/>
				}
				secondaryAction={
					<Btn
						onClickFunction={() => handleClose()}
						message="Cancel"
						color="secondary"
						style="ghost"
					/>
				}
			>
			</ModalFooter>
		</Modal>
	);
}